import http from "infra/http";
import { useQuery } from "react-query";

import { PaginateResult } from "core/resources/types/shared";
import { RetornoBancariaPaginate, RetornoBancarioPaginateFiltro } from "../typings";

function useRetornosBancarios(filtro: RetornoBancarioPaginateFiltro) {
  const queryResult = useQuery([`/v1/retorno-bancario`], async () => {
    const { data } = await http.get<PaginateResult<RetornoBancariaPaginate>>(
      `/v1/retorno-bancario`,
      {
        params: filtro,
      }
    );

    return data;
  });

  return {
    ...queryResult,
  };
}

export default useRetornosBancarios;
